import React, { useContext } from 'react';

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker
} from 'react-simple-maps';

import { MapContext } from '../contexts/map';
import { SLATE_GREY_60 } from '../utils/variables';

const geoUrl =
  'https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries.json';

export default function Map() {
  const { pickupLocation, deliveryLocation, showMessage } =
    useContext(MapContext);

  const cityCoordinates = (city) => [
    city?.formatted_location?.geometry?.location?.lng,
    city?.formatted_location?.geometry?.location?.lat
  ];

  return (
    <div className={`map ${showMessage ? '--expanded' : ''}`}>
      <ComposableMap>
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography key={geo.rsmKey} geography={geo} fill={'white'} />
            ))
          }
        </Geographies>

        <>
          {pickupLocation && (
            <Marker coordinates={cityCoordinates(pickupLocation)}>
              <circle r={3} fill={SLATE_GREY_60} />
            </Marker>
          )}
          {deliveryLocation && (
            <Marker coordinates={cityCoordinates(deliveryLocation)}>
              <circle r={3} fill={SLATE_GREY_60} />
            </Marker>
          )}
        </>
      </ComposableMap>
    </div>
  );
}
